/* eslint-disable no-use-before-define */
import { lcmApiClient } from "lcm-iot-commons";
import { extractEdgeDevices } from "../extractors/edgeDevicesExtractor";

/* istanbul ignore next */
export async function loadEdgeDevices(parameters: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient().get("/edm/edge_devices", {
    ...parameters,
    include: "status, type, add_on",
  });
  return {
    edgeDevices: extractEdgeDevices(response),
    totalCount: (response as $TSFixMe).pagination.total_count,
    nextPageUrl: (response as $TSFixMe).pagination.next,
  };
}

/* istanbul ignore next */
export async function loadNextEdgeDevices(nextPageUrl: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 1.
  const response = await lcmApiClient().get(nextPageUrl);
  return {
    edgeDevices: extractEdgeDevices(response),
    totalCount: (response as $TSFixMe).pagination.total_count,
    nextPageUrl: (response as $TSFixMe).pagination.next,
  };
}

/* istanbul ignore next */
export async function loadEdgeDeviceApplications(
  edgeDeviceTypeId: $TSFixMe,
  parameters: $TSFixMe,
) {
  const edgeDeviceApplicationTypeId =
    // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
    (await loadPublicEdgeDeviceApplicationType()).id;
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient(false).getAll(
    `/edm/edge_device/application/types/${edgeDeviceApplicationTypeId}/applications`,
    {
      edge_device_type_id: edgeDeviceTypeId,
      ...parameters,
    },
  );
  return {
    edgeDeviceApplications: (response as $TSFixMe).edge_device_applications,
  };
}

/* istanbul ignore next */
export async function loadPublicEdgeDeviceApplicationType(
  parameters: $TSFixMe,
) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient(false).getAll(
    "/edm/edge_device/application/types",
    {
      code: "public",
      ...parameters,
    },
  );
  return (response as $TSFixMe).edge_device_application_types[0];
}

/* istanbul ignore next */
export async function loadEnabledEdgeDeviceApplications(
  edgeDeviceId: $TSFixMe,
  parameters: $TSFixMe,
) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient(false).getAll(
    `/edm/edge_devices/${edgeDeviceId}/applications`,
    parameters,
  );
  return {
    edgeDeviceApplications: (response as $TSFixMe).edge_device_applications,
  };
}

/* istanbul ignore next */
export async function assignEdgeDeviceApplications(
  edgeDeviceId: $TSFixMe,
  body: $TSFixMe,
) {
  return lcmApiClient().post(
    `/edm/edge_devices/${edgeDeviceId}/applications`,
    body,
  );
}

/* istanbul ignore next */
export async function unassignEdgeDeviceApplications(
  edgeDeviceId: $TSFixMe,
  body: $TSFixMe,
) {
  return lcmApiClient().delete(
    `/edm/edge_devices/${edgeDeviceId}/applications`,
    body,
  );
}

/* istanbul ignore next */
export async function removeEdgeDevice(edgeDeviceId: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 2-3 arguments, but got 1.
  return lcmApiClient().patch(`/edm/edge_devices/${edgeDeviceId}/unlink`);
}

/* istanbul ignore next */
export async function loadEdgeDeviceAddOn(url: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 1.
  return lcmApiClient(false).get(url);
}

export async function loadEdgeDeviceUplinkAddons() {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 1.
  return lcmApiClient().get(
    "/add_ons?scope=USABLE&add_on_type=connectivity&product_code=uplink&include=addonable_name",
  );
}

/* istanbul ignore next */
export async function resetEdgeDeviceTechnicalUserPassword(
  edgeDeviceId: $TSFixMe,
) {
  // @ts-expect-error TS(2554) FIXME: Expected 2-3 arguments, but got 1.
  return lcmApiClient().post(
    `/edm/edge_devices/${edgeDeviceId}/technical_users/password_reset`,
  );
}
